module.exports=function(scope){ return `// Signal to the FaceTec SDK that time based session images should be captured
ZoomSDK.setTimeBasedSessionImagesEnabled(true);

// Capture a User Session
Intent sessionIntent = new Intent(this, ZoomSessionActivity.class);
startActivityForResult(sessionIntent, ZoomSDK.REQUEST_CODE_SESSION);

// Sample code to handle the session result
private void handleZoomSessionResult(ZoomSessionResult result) {

    // Capture failed
    if(result.getStatus() != ZoomSessionStatus.USER_PROCESSED_SUCCESSFULLY) {
        // Handle results here
        return;
    }

    if(result.getFaceMetrics() != null) {
        // Get the time based image(s) if available
        ArrayList<Bitmap> timeBasedSessionImages = result.getFaceMetrics().getTimeBasedSessionImages();
        stringBuilder.append("number of of Time Based Session Images Images: ");
        stringBuilder.append(timeBasedSessionImages.size());
    }
    // Send the data to your chosen API for processing
}
`};


// WEBPACK FOOTER //
// ./src/resources/code/android/37-time-based-images.java.tpl